// extracted by mini-css-extract-plugin
export default {"container":"SubcalcsContainer_container__6m4Ve"};